const ANIMATION_SPEED = 0.4;
const ANIMATION_SPEED_FAST = 0.1;

export { ANIMATION_SPEED, ANIMATION_SPEED_FAST };
